import Vue from 'vue';

class FixHeight {
    fix(selector, minWidth) {
        // Default the min to 0
        if (minWidth == null) {
            minWidth = 767;
        }

        let min = 0;
        // Get the elements to resize
        const $elements = $(selector);
        // Reset their height
        $elements.css({
            height: 'auto',
        });
        // If they are on greater than mobile viewport
        if ($(window).width() > minWidth) {
            // Loop the elements and set their height to the
            // maximum element height
            $elements.each(function(i, el) {
                if ($(el).outerHeight() > min) {
                    return min = $(el).outerHeight();
                }
            }).css({
                height: min,
            });
        }
    }
}

/**
 * Basic directive for setting blocks to be the same height
 */
export default {
    bind(el, binding) {
        const fixHeight = new FixHeight;
        function fixHeightFunc() {
            if (typeof binding.value.el === 'string') {
                fixHeight.fix($(el).find(binding.value.el), binding.value.minWidth);
                Vue.nextTick(() => {
                    fixHeight.fix($(el).find(binding.value.el), binding.value.minWidth);
                });
            } else if (typeof binding.value.el === 'object') {
                for (let elem of binding.value.el) {
                    fixHeight.fix($(el).find(elem), binding.value.minWidth);
                    Vue.nextTick(() => {
                        fixHeight.fix($(el).find(elem), binding.value.minWidth);
                    });
                }
            }
        }

        $(document).on('load', fixHeightFunc);
        $(document).on('fixHeight', fixHeightFunc);

        fixHeightFunc();
        $(el).find(binding.value.el).on('fixHeight', fixHeightFunc);
        $(el).on('fixHeight', fixHeightFunc);
        $(window).resize(fixHeightFunc);
        $(el).on('lazybeforeunveil', fixHeightFunc);
        $(el).find('img').on('load', fixHeightFunc);
        $(el).find('img').on('lazybeforeunveil', fixHeightFunc);

        setTimeout(() => {
            $(el).closest('.modal').on('show.bs.modal shown.bs.modal', () => {
                fixHeightFunc();
                setTimeout(() => fixHeightFunc, 0);
                Vue.nextTick(fixHeightFunc);
            });
        }, 0);
    },

    inserted(el, binding) {
        const fixHeight = new FixHeight;
        fixHeight.fix($(el).find(binding.value.el), binding.value.minWidth);
    },

    update(el, binding) {
        const fixHeight = new FixHeight;
        fixHeight.fix($(el).find(binding.value.el), binding.value.minWidth);
    },

    componentUpdates(el, binding) {
        const fixHeight = new FixHeight;
        fixHeight.fix($(el).find(binding.value.el), binding.value.minWidth);
    },
};


